var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Container, Spinner, Alert } from 'reactstrap';
import CalendarHeader from '../components/CalendarHeader';
import CalendarGrid from '../components/CalendarGrid';
import SlotDetailModal from '../components/SlotDetailModal';
var CalendarView = /** @class */ (function (_super) {
    __extends(CalendarView, _super);
    function CalendarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarView.prototype.componentDidMount = function () {
        var store = this.props.store;
        store.operationalCalendarStore.fetchSlots();
    };
    CalendarView.prototype.render = function () {
        var store = this.props.store;
        var operationalCalendarStore = store.operationalCalendarStore;
        if (!store)
            return null;
        return (React.createElement(Container, { fluid: true, className: "operational-calendar py-3" },
            React.createElement(CalendarHeader, { store: operationalCalendarStore }),
            operationalCalendarStore.error && (React.createElement(Alert, { color: "danger", className: "mt-3" }, operationalCalendarStore.error)),
            operationalCalendarStore.loading ? (React.createElement("div", { className: "text-center py-5" },
                React.createElement(Spinner, { color: "primary" }),
                React.createElement("p", { className: "mt-2 text-muted" }, "Cargando..."))) : (React.createElement(CalendarGrid, { store: operationalCalendarStore })),
            React.createElement(SlotDetailModal, { store: operationalCalendarStore })));
    };
    CalendarView = __decorate([
        inject('store'),
        observer
    ], CalendarView);
    return CalendarView;
}(Component));
export default CalendarView;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/containers/CalendarView.tsx
// module id = 1607
// module chunks = 0